export const qualities: IQualities = {
  '1': {
    id: '1',
    generatorId: 'G-1000',
    interactionId: '1',
    latency: 1041,
    prompt: 'Make it bigger',
    service: 'IMAGE-TO-3D',
    createdAt: '2025-10-01T12:15:00Z',
    stars: 4,
  },
  '2': {
    id: '2',
    generatorId: 'G-1002',
    interactionId: '2',
    latency: 1641,
    prompt: 'Make it smaller',
    service: 'SODA',
    createdAt: '2025-10-02T14:40:00Z',
    isSubscriber: true,
  },
};
